import AppRouter from '../../router/AppRouter';
import React from 'react';
import useAuth from '../../auth/authContext';
import { AuthenticatedAppRoot } from './AuthenticatedAppRoot';

export const AppRoot = () => {
  const {
    state: { user },
  } = useAuth();

  return user ? <AuthenticatedAppRoot /> : <AppRouter />;
};
